import * as types from "./editSiteProfileActionType";

// Fetch Site Details Actions
export const fetchSiteDetailsRequest = (siteId) => ({
  type: types.FETCH_SITE_DETAILS_REQUEST,
  payload: { siteId },
});

export const fetchSiteDetailsSuccess = (data) => ({
  type: types.FETCH_SITE_DETAILS_SUCCESS,
  payload: data,
});

export const fetchSiteDetailsFailure = (error) => ({
  type: types.FETCH_SITE_DETAILS_FAILURE,
  payload: error,
});

// Fetch Zipcode Details Actions
export const fetchZipcodeDetailsRequest = (zipcode) => ({
  type: types.FETCH_ZIPCODE_DETAILS_REQUEST,
  payload: { zipcode },
});

export const fetchZipcodeDetailsSuccess = (data) => ({
  type: types.FETCH_ZIPCODE_DETAILS_SUCCESS,
  payload: data,
});

export const fetchZipcodeDetailsFailure = (error) => ({
  type: types.FETCH_ZIPCODE_DETAILS_FAILURE,
  payload: error,
});

// Save Site Details Actions
export const saveSiteDetailsRequest = (siteData) => ({
  type: types.SAVE_SITE_DETAILS_REQUEST,
  payload: siteData,
});

export const saveSiteDetailsSuccess = (data) => ({
  type: types.SAVE_SITE_DETAILS_SUCCESS,
  payload: data,
});

export const saveSiteDetailsFailure = (error) => ({
  type: types.SAVE_SITE_DETAILS_FAILURE,
  payload: error,
});

// Save Priority SLA Actions
export const savePrioritySlaRequest = (prioritySlaData) => ({
  type: types.SAVE_PRIORITY_SLA_REQUEST,
  payload: prioritySlaData,
});

export const savePrioritySlaSuccess = (data) => ({
  type: types.SAVE_PRIORITY_SLA_SUCCESS,
  payload: data,
});

export const savePrioritySlaFailure = (error) => ({
  type: types.SAVE_PRIORITY_SLA_FAILURE,
  payload: error,
});

// Save Site Tags Actions
export const saveSiteTagsRequest = (payload, onSuccess = null) => ({
  type: types.SAVE_SITE_TAGS_REQUEST,
  payload,
  onSuccess,
});

export const saveSiteTagsSuccess = (data) => ({
  type: types.SAVE_SITE_TAGS_SUCCESS,
  payload: data,
});

export const saveSiteTagsFailure = (error) => ({
  type: types.SAVE_SITE_TAGS_FAILURE,
  payload: error,
});

// Fetch Sister Sites Actions
export const fetchSisterSitesRequest = (siteId) => ({
  type: types.FETCH_SISTER_SITES_REQUEST,
  payload: { siteId },
});

export const fetchSisterSitesSuccess = (data) => ({
  type: types.FETCH_SISTER_SITES_SUCCESS,
  payload: data,
});

export const fetchSisterSitesFailure = (error) => ({
  type: types.FETCH_SISTER_SITES_FAILURE,
  payload: error,
});

// Fetch Site Alias Actions
export const fetchSiteAliasRequest = (siteId) => ({
  type: types.FETCH_SITE_ALIAS_REQUEST,
  payload: { siteId },
});

export const fetchSiteAliasSuccess = (data) => ({
  type: types.FETCH_SITE_ALIAS_SUCCESS,
  payload: data,
});

export const fetchSiteAliasFailure = (error) => ({
  type: types.FETCH_SITE_ALIAS_FAILURE,
  payload: error,
});

// Fetch Site Alias History Actions
export const fetchSiteAliasHistoryRequest = (siteAliasDetailId) => ({
  type: types.FETCH_SITE_ALIAS_HISTORY_REQUEST,
  payload: { siteAliasDetailId },
});

export const fetchSiteAliasHistorySuccess = (data) => ({
  type: types.FETCH_SITE_ALIAS_HISTORY_SUCCESS,
  payload: data,
});

export const fetchSiteAliasHistoryFailure = (error) => ({
  type: types.FETCH_SITE_ALIAS_HISTORY_FAILURE,
  payload: error,
});

// Fetch Sister Site History Actions
export const fetchSisterSiteHistoryRequest = (sisterSiteId) => ({
  type: types.FETCH_SISTER_SITE_HISTORY_REQUEST,
  payload: { sisterSiteId },
});

export const fetchSisterSiteHistorySuccess = (data) => ({
  type: types.FETCH_SISTER_SITE_HISTORY_SUCCESS,
  payload: data,
});

export const fetchSisterSiteHistoryFailure = (error) => ({
  type: types.FETCH_SISTER_SITE_HISTORY_FAILURE,
  payload: error,
});

// Save Site Alias Actions
export const saveSiteAliasRequest = (siteAliasData, onSuccess = null) => ({
  type: types.SAVE_SITE_ALIAS_REQUEST,
  payload: siteAliasData,
  onSuccess,
});

export const saveSiteAliasSuccess = (data) => ({
  type: types.SAVE_SITE_ALIAS_SUCCESS,
  payload: data,
});

export const saveSiteAliasFailure = (error) => ({
  type: types.SAVE_SITE_ALIAS_FAILURE,
  payload: error,
});

// Fetch Model Input Files Actions
export const fetchModelInputFilesRequest = (siteId) => ({
  type: types.FETCH_MODEL_INPUT_FILES_REQUEST,
  payload: { siteId },
});

export const fetchModelInputFilesSuccess = (data) => ({
  type: types.FETCH_MODEL_INPUT_FILES_SUCCESS,
  payload: data,
});

export const fetchModelInputFilesFailure = (error) => ({
  type: types.FETCH_MODEL_INPUT_FILES_FAILURE,
  payload: error,
});

// Fetch Model Input Files(Processed Result) Actions
export const fetchModelInputProcessedFilesRequest = (siteId) => ({
  type: types.FETCH_MODEL_PROCESSED_FILES_REQUEST,
  payload: { siteId },
});

export const fetchModelInputProcessedFilesSuccess = (data) => ({
  type: types.FETCH_MODEL_PROCESSED_FILES_SUCCESS,
  payload: data,
});

export const fetchModelInputProcessedFilesFailure = (error) => ({
  type: types.FETCH_MODEL_PROCESSED_FILES_FAILURE,
  payload: error,
});

// Fetch Site Model Filter Actions
export const fetchSiteModelFilterRequest = (filterPayload) => ({
  type: types.FETCH_SITE_MODEL_FILTER_REQUEST,
  payload: filterPayload,
});

export const fetchSiteModelFilterSuccess = (data) => ({
  type: types.FETCH_SITE_MODEL_FILTER_SUCCESS,
  payload: data,
});

export const fetchSiteModelFilterFailure = (error) => ({
  type: types.FETCH_SITE_MODEL_FILTER_FAILURE,
  payload: error,
});

// Download Site Model Input Template Actions
export const downloadSiteModelInputTemplateRequest = (
  siteModelInputFileName = "FacilityModelInputTemplate_(2)_050525_080254.xlsx",
) => ({
  type: types.DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_REQUEST,
  payload: { siteModelInputFileName },
});

export const downloadSiteModelInputTemplateSuccess = (data) => ({
  type: types.DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_SUCCESS,
  payload: data,
});

export const downloadSiteModelInputTemplateFailure = (error) => ({
  type: types.DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_FAILURE,
  payload: error,
});

// Upload Site Model Input File Actions
export const uploadSiteModelInputRequest = (file, siteId, createdBy) => ({
  type: types.SITE_MODEL_INPUT_UPLOAD_REQUEST,
  payload: { file, siteId, createdBy },
});

export const uploadSiteModelInputSuccess = (data) => ({
  type: types.SITE_MODEL_INPUT_UPLOAD_SUCCESS,
  payload: data,
});

export const uploadSiteModelInputFailure = (error) => ({
  type: types.SITE_MODEL_INPUT_UPLOAD_FAILURE,
  payload: error,
});

// Save Site Model Input Actions
export const saveSiteModelInputRequest = (payload) => ({
  type: types.SAVE_SITE_MODEL_INPUT_REQUEST,
  payload,
});

export const saveSiteModelInputSuccess = (data) => ({
  type: types.SAVE_SITE_MODEL_INPUT_SUCCESS,
  payload: data,
});

export const saveSiteModelInputFailure = (error) => ({
  type: types.SAVE_SITE_MODEL_INPUT_FAILURE,
  payload: error,
});

// Fetch Priority / Subspeciality Split Actions
export const fetchPrioritySubspecialitySplitRequest = (siteId) => ({
  type: types.FETCH_PRIORITY_SUBSPECIALITY_SPLIT_REQUEST,
  payload: { siteId },
});

export const fetchPrioritySubspecialitySplitSuccess = (data) => ({
  type: types.FETCH_PRIORITY_SUBSPECIALITY_SPLIT_SUCCESS,
  payload: data,
});

export const fetchPrioritySubspecialitySplitFailure = (error) => ({
  type: types.FETCH_PRIORITY_SUBSPECIALITY_SPLIT_FAILURE,
  payload: error,
});

// Save Priority / Subspeciality Split Actions
export const savePrioritySubspecialitySplitRequest = (payload) => ({
  type: types.SAVE_PRIORITY_SUBSPECIALITY_SPLIT_REQUEST,
  payload,
});

export const savePrioritySubspecialitySplitSuccess = (data) => ({
  type: types.SAVE_PRIORITY_SUBSPECIALITY_SPLIT_SUCCESS,
  payload: data,
});

export const savePrioritySubspecialitySplitFailure = (error) => ({
  type: types.SAVE_PRIORITY_SUBSPECIALITY_SPLIT_FAILURE,
  payload: error,
});

// Check Priority / Subspeciality Config Availability Actions
export const checkPrioritySubspecialityConfigBySiteIdRequest = (payload) => ({
  type: types.CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_REQUEST,
  payload,
});

export const checkPrioritySubspecialityConfigBySiteIdSuccess = (data) => ({
  type: types.CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_SUCCESS,
  payload: data,
});

export const checkPrioritySubspecialityConfigBySiteIdFailure = (error) => ({
  type: types.CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_FAILURE,
  payload: error,
});

// Enable / Disable Sister Site Actions
export const enableDisableSisterSiteRequest = (payload) => ({
  type: types.ENABLE_DISABLE_SISTER_SITE_REQUEST,
  payload,
});

export const enableDisableSisterSiteSuccess = (data) => ({
  type: types.ENABLE_DISABLE_SISTER_SITE_SUCCESS,
  payload: data,
});

export const enableDisableSisterSiteFailure = (error) => ({
  type: types.ENABLE_DISABLE_SISTER_SITE_FAILURE,
  payload: error,
});

//Get Site Onboarding Details Actions
export const fetchSiteOnboardingDetailsRequest = (SiteOnboardingID) => ({
  type: types.FETCH_SITE_ONBOARDING_DETAILS_REQUEST,
  payload: { SiteOnboardingID },
});

export const fetchSiteOnboardingDetailsSuccess = (data) => ({
  type: types.FETCH_SITE_ONBOARDING_DETAILS_SUCCESS,
  payload: data,
});

export const fetchSiteOnboardingDetailsFailure = (error) => ({
  type: types.FETCH_SITE_ONBOARDING_DETAILS_FAILURE,
  payload: error,
});

// State list
export const fetchStateListRequest = () => ({
  type: types.FETCH_STATE_LIST_REQUEST,
});
export const fetchStateListSuccess = (data) => ({
  type: types.FETCH_STATE_LIST_SUCCESS,
  payload: data,
});
export const fetchStateListFailure = (error) => ({
  type: types.FETCH_STATE_LIST_FAILURE,
  payload: error,
});

// Update site scheduling state
export const updateSiteStateRequest = (siteId, stateId) => ({
  type: types.UPDATE_SITE_STATE_REQUEST,
  payload: { siteId, stateId },
});
export const updateSiteStateSuccess = () => ({
  type: types.UPDATE_SITE_STATE_SUCCESS,
});
export const updateSiteStateFailure = (error) => ({
  type: types.UPDATE_SITE_STATE_FAILURE,
  payload: error,
});
